import React from 'react'
import Departments from '../../../../components/Project/Resources/Departments/Departments'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { DepartmentsApi, remove as removeApi } from '../../../../api/Projects/Resources'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'

function DepartmentsCont (props) {
  const { project } = props
  const { list, fetching, fetch } = useFetchList(() =>
    DepartmentsApi.list(project._id, 'departments'),
  )
  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const {
    visible,
    modalType,
    object: department,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(
    DepartmentsApi.create,
    DepartmentsApi.update,
    removeApi,
    fetch,
  )

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await DepartmentsApi.create({ ...newObject, project })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <Departments
      {...{
        project,
        list,
        fetching,
        submitting,
        visible,
        fetch,
        department,
        onShow,
        onCancel,
        checkForm,
        submit,
        update,
        removing,
        remove,
        modalType,
        formRef,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

DepartmentsCont.propTypes = {}
DepartmentsCont.defaultProps = {}

export default (DepartmentsCont)
